import React from 'react';

const ShowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M3.9074 9.15134C7.53762 2.94955 16.4624 2.94955 20.0926 9.15134C21.3025 11.2182 21.3025 13.7818 20.0926 15.8487C16.4624 22.0504 7.53762 22.0504 3.9074 15.8487C2.69753 13.7818 2.69753 11.2182 3.9074 9.15134Z" stroke="#8181A5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M15.5567 12.5607C15.5567 14.5561 13.9637 16.1733 11.9994 16.1733C10.0352 16.1733 8.44331 14.5561 8.44331 12.5607C8.44331 10.5641 10.0352 8.94699 11.9994 8.94699C13.9637 8.94699 15.5567 10.5641 15.5567 12.5607Z" stroke="#8181A5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default ShowIcon;